import { Component, OnInit } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { Input } from '@angular/core';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { ViewChild } from '@angular/core';
import swal from "sweetalert2";
import { FormGroup } from '@angular/forms';
import { FormBuilder } from '@angular/forms';
import { Validators } from '@angular/forms';
import { ValidationErrors } from '@angular/forms';
import { ValidatorFn } from '@angular/forms';
import { AbstractControl } from '@angular/forms';
import { UserService } from '../../services/user.service';
import { SignUpDto } from '../../../../dtos/signUpDto';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { SignInDto } from '../../../../dtos/sign-in.dto';
import { combineLatest } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

declare var grecaptcha;

@Component({
    selector: 'app-signup-window',
    templateUrl: './signup-window.component.html',
    styleUrls: ['./signup-window.component.scss']
})
export class SignupWindowComponent implements OnInit, AfterViewInit {

    @ViewChild("signUpForm")
    private signUpForm;

    signUpRequestForm: FormGroup;
    submited = false;

    @Input()
    signUpTrigger: boolean;
    @Output()
    signUpTriggerChange: EventEmitter<any> = new EventEmitter<any>();

    socialRegistrationProblem = false;

    loading = false;

    constructor(private formBuilder: FormBuilder, private userService: UserService,
                private translateService: TranslateService) {
    }

    ngOnInit(): void {
        this.signUpRequestForm = this.formBuilder.group({
            firstname: ['', Validators.required],
            lastname: ['', Validators.required],
            email: ['', Validators.compose([Validators.required, Validators.email])],
            password: [null, Validators.compose([
                // 1. Password Field is Required
                Validators.required,
                // 2. check whether the entered password has a number
                this.patternValidator(/\d/, {hasNumber: true}),
                // 3. check whether the entered password has upper case letter
                this.patternValidator(/[A-Z]/, {hasCapitalCase: true}),
                // 4. check whether the entered password has a lower-case letter
                this.patternValidator(/[a-z]/, {hasSmallCase: true}),
                // 6. Has a minimum length of 6 characters
                Validators.minLength(6),
                // 7. Has a minimum length of 13 characters
                Validators.maxLength(13),
                // 4. check whether the entered password has a lower-case letter
                this.patternValidator(/^\S*$/, {hasSpace: true}),
            ])]
        });
    }

    ngAfterViewInit(): void {
        combineLatest([this.translateService.get("TRANS_REMOTE_SIGNUP.TRANS_HEAD"),
            this.translateService.get("TRANS_REMOTE_SIGNUP.TRANS_SIGN")])
            .subscribe((values) => {
                swal({
                    title: '<strong>' + values[0] + '</strong>',
                    html: '&nbsp;',
                    showCloseButton: true,
                    showCancelButton: false,
                    focusConfirm: false,
                    confirmButtonText: values[1],
                    confirmButtonAriaLabel: 'Thumbs up, great!',
                    cancelButtonAriaLabel: 'Thumbs down',
                    preConfirm: () => {
                        setTimeout(() => {
                            this.loading = true;
                            this.submitForm();
                        })
                        return false;
                    }
                }).then((reason) => {
                    this.signUpTrigger = false;
                    this.signUpTriggerChange.emit(this.signUpTrigger);
                });
                setTimeout(() => {
                    //swal2-content
                    const loginElement = this.signUpForm.nativeElement;
                    document.getElementById('swal2-content').appendChild(loginElement);
                    loginElement.style.display = 'block';
                }, 50)
            })

    }

    socialValidation(noValid) {
        this.socialRegistrationProblem = noValid;
        if (!noValid) {
            swal.close();
            this.signUpTrigger = false;
            this.signUpTriggerChange.emit(this.signUpTrigger);
        }
    }

    private patternValidator(regex: RegExp, error: ValidationErrors): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            if (!control.value) {
                // if control is empty return no error
                return null;
            }

            // test the value of the control against the regexp supplied
            const valid = regex.test(control.value);

            // if true, return no error (no error), else return error passed in the second parameter
            return valid ? null : error;
        };
    }

    private submitForm() {
        this.submited = true;
        if (this.signUpRequestForm.valid) {
            grecaptcha.ready(() => {
                grecaptcha.execute('6Ldffd8ZAAAAADIJiux6tbU-ApsawUGHqbsMOday', {action: 'submit'}).then(
                    (token) => {
                        // Add your logic to submit to your backend server here.
                        let signUpDto = new SignUpDto();
                        signUpDto.token = token
                        signUpDto.email = this.signUpRequestForm.controls.email.value;
                        signUpDto.name = this.signUpRequestForm.controls.firstname.value;
                        signUpDto.lastName = this.signUpRequestForm.controls.lastname.value;
                        signUpDto.password = this.signUpRequestForm.controls.password.value;
                        signUpDto.username = this.signUpRequestForm.controls.firstname.value.toLowerCase() + '.' + this.signUpRequestForm.controls.lastname.value.toLowerCase()
                        this.userService.signUp(signUpDto)
                            .pipe(
                                catchError((err) => {
                                    this.socialRegistrationProblem = true
                                    this.loading = false;
                                    return EMPTY;
                                })
                            )
                            .subscribe(() => {
                                const signInDto = new SignInDto();
                                signInDto.usernameOrEmail = signUpDto.email;
                                signInDto.password = signUpDto.password;
                                this.userService.validateUser(signInDto)
                                    .then(() => {
                                        swal.close();
                                        this.signUpTrigger = false;
                                        this.signUpTriggerChange.emit(this.signUpTrigger);
                                    })
                            });
                    });
            });
        } else {
            this.loading = false;
        }
    }
}